/**
 * usage 模块接口
 */
import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const usage = {
	/**
	 * 根据id获取详情数据
	 */
	getUsageDetails(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/use-help/details`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 获取使用帮助列表
	 */
	getUsageList(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/use-help/index`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	}
};

export default usage;
